import styled from 'styled-components';
import { PopperBox } from '@m/alchemy-ui/PopperBox';

export const Popup = styled(PopperBox)`
  width: 200px;

  & > div:last-child {
    padding: 16px 16px 3px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    max-height: 200px;
    overflow-y: auto;
  }

  li {
    display: flex;
    align-items: center;
    font:
      400 14px/1.3 'Nunito',
      -apple-system,
      BlinkMacSystemFont,
      helvetica,
      arial,
      sans-serif;
  }

  li:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const Title = styled.div`
  margin: 0 0 8px 0;
  padding: 0;
  font:
    700 14px 'Nunito',
    -apple-system,
    BlinkMacSystemFont,
    helvetica,
    arial,
    sans-serif;
  color: #2c3548;
  text-transform: none;
`;

export const AuthorAvatar = styled.div`
  display: flex;
  align-items: center;
  width: 30px;
  height: 30px;
`;

export const AvatarImage = styled.img`
  display: inline-block;
  border-radius: 50%;
  overflow: hidden;
  min-width: 24px;
  min-height: 24px;
  max-width: 24px;
  max-height: 24px;
`;

export const AuthorName = styled.div`
  margin-left: 10px;
  max-width: 130px;
  word-break: break-word;
`;
